import Model, { attr } from '@ember-data/model';

import type { ImageCropData, RecordData } from 'webapp-types';
import { DesignerLayout, UserAccess } from 'webapp/enums/enums';
import type { VerificationInfo } from 'webapp/utils/verification';

export const DEFAULT_BG_IMAGE_OPACITY = 0.1;
export default class BoardRecord extends Model {
	@attr('string', { defaultValue: 'Untitled dashboard' }) name!: string;
	@attr('string') color!: string;
	@attr('number') order!: number;
	@attr('number') fromTemplate!: number | null;

	@attr('number') lastSync!: number;
	@attr('number') created!: number;
	@attr('number') createdById!: number;
	@attr('number') ownerId?: number | null;
	@attr('number') modified!: number;
	@attr('number') modifiedById!: number;
	@attr('number') originateFrom!: number | null;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	users!: number[];
	@attr('boolean') isRandom!: boolean;
	@attr('boolean') favorite!: boolean;
	@attr('number') deleted!: number | null;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	sources!: RecordData.Board.Source[];
	@attr('boolean') hidden!: boolean;
	@attr('string') token!: string; // token
	@attr('boolean', { defaultValue: false }) declare isPublicEnabled: boolean;
	@attr('string') image!: string; // url to preview image (cdn)
	@attr('number', { defaultValue: 1 }) themeId!: number; // color theme id (const/theme-config)
	@attr('number', { defaultValue: UserAccess.PUBLIC }) access!: UserAccess;
	@attr('number') templateId!: number | null;
	@attr('number') spaceId!: number;
	@attr('boolean', { defaultValue: true }) allowAnonymousDateRangeEdit!: boolean;
	@attr('boolean', { defaultValue: true }) allowAnonymousFilterEdit!: boolean;

	// seperate settings that will be serialized to 'settings' field
	@attr('number', { defaultValue: DesignerLayout.DESKTOP }) primaryView!: DesignerLayout; // preferred view
	@attr('string') logo!: string; // logo url (cropped)
	@attr('string') logoOriginal!: string; // logo url (original)
	@attr('object') logoCrop!: ImageCropData | null; // logo crop data
	@attr('string') bg!: string; // bg image url (cropped)
	@attr('string') bgOriginal!: string; // bg image url (original)
	@attr('object') bgCrop!: ImageCropData | null; // bg image crop data
	@attr('number', { defaultValue: DEFAULT_BG_IMAGE_OPACITY }) declare bgOpacity: number; // bg image opacity
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	restrictIps!: string[]; // restrict to IPs
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	tags!: number[]; // board tags
	@attr('string') password!: string; // datawall password
	@attr('boolean') isTemplate!: boolean;
	@attr('object') verificationInfo?: VerificationInfo;

	// only for internal webapp use
	@attr('boolean') newBadge!: boolean;

	// flag used on BE only for onboarding (creating board from sample template)
	// https://app.asana.com/1/7582066485656/project/1138028810573038/task/1213262067285232
	@attr('boolean') isSample!: boolean;
}
